import React, { useState } from 'react'
import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'

import { Dialog, snackbar } from 'components'
import { useApiCall, useCheckFormErrors } from 'hooks'

import { UserPoll, UpdateUserPollResponse, UpdateUserPollData } from '../../types'
import { updateUserPoll } from '../../api'
import { constants } from '../../constansts'

const rules = {
  question: [
    {
      validate: (value: string) => value.length <= 254,
      message: 'No puede superar los 254 caracteres',
    },
  ],
}

const requiredFields = ['question', 'expiryDate', 'active']

interface UpdateUserPollDialogProps {
  handleClose: () => void
  userPollToUpdate: UserPoll
  onDone: (newUserPoll: UserPoll) => void
}

const UpdateUserPollDialog: React.FC<UpdateUserPollDialogProps> = ({
  handleClose,
  onDone,
  userPollToUpdate,
}) => {
  const [multiple_answers, setMultipleAnswers] = useState(
    userPollToUpdate.multiple_answers ?? false,
  )
  const [question, setQuestion] = useState(userPollToUpdate.question ?? '')
  const [active, setActive] = useState(userPollToUpdate.active)

  const [updateUserPollApi, isLoading] = useApiCall<UpdateUserPollData, UpdateUserPollResponse>(
    updateUserPoll,
  )
  const handleChangeMultipleAnswers: React.ChangeEventHandler<HTMLInputElement> = e => {
    setMultipleAnswers(e.target.checked)
  }
  const handlequestionChange: React.ChangeEventHandler<HTMLInputElement> = e => {
    setQuestion(e.target.value)
  }

  const handleChangeActive: React.ChangeEventHandler<HTMLInputElement> = e => {
    setActive(!active)
  }

  const fields = { question, active }
  const { hasErrors, isAnyFieldEmpty, errors } = useCheckFormErrors(fields, rules, requiredFields)
  const isSubmitDisabled = hasErrors || isAnyFieldEmpty || isLoading

  const onUpdateUserPoll = async () => {
    const userPoll = {
      question,
      active,
      multiple_answers,
    }
    const payload = {
      id: userPollToUpdate.id,
      payload: userPoll,
    }
    try {
      const { userPoll: updatedUserPoll } = await updateUserPollApi(payload)
      onDone(updatedUserPoll)
    } catch (err) {
      console.error('API Error:', err)

      const baseMessage = `No se pudo editar ${constants.TEST_NAME}.`
      const apiErrorMessage = err

      const finalMessage = apiErrorMessage ? `${baseMessage} ${apiErrorMessage}` : baseMessage

      snackbar.show(String(finalMessage)) // Forzamos a string
    }
  }

  return (
    <Dialog
      title={`Editar ${constants.TEST_NAME}`}
      isOpen
      showActions
      onCancel={handleClose}
      isLoading={isLoading}
      okButtonText="Editar"
      okButtonProps={{ disabled: isSubmitDisabled }}
      onAccept={onUpdateUserPoll}
    >
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <TextField
            label="Pregunta"
            value={question}
            fullWidth
            onChange={handlequestionChange}
            disabled={isLoading}
            multiline
            error={errors.question.hasError}
            helperText={errors.question.message}
          />
        </Grid>
        <Grid item xs={11}>
          <FormControlLabel
            control={<Checkbox onChange={handleChangeActive} checked={active !== null && active} />}
            label="Activar"
          />
        </Grid>
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Checkbox
                checked={multiple_answers}
                onChange={handleChangeMultipleAnswers}
                color="primary"
                disabled={isLoading}
              />
            }
            label="Múltiples respuestas"
          />
        </Grid>
      </Grid>
    </Dialog>
  )
}

export { UpdateUserPollDialog }
